import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { offerSelector, selectSpecialProject, selectSpecialPromoInfo, selectMapTabs } from 'shared/selectors';

import { OfferMapTabs } from './tabs';
import { TMapTab, changeTab } from '../../store/map_tabs';

export const OfferMapTabsContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { activeTab } = useSelector(selectMapTabs);
  const offer = useSelector(offerSelector);
  const specialProject = useSelector(selectSpecialProject);
  const specialPromoInfo = useSelector(selectSpecialPromoInfo);

  const handleTabChange = React.useCallback(
    (tab: TMapTab) => {
      dispatch(changeTab(tab));
    },
    [dispatch],
  );

  return (
    <OfferMapTabs
      activeTab={activeTab}
      offer={offer}
      specialProject={specialProject}
      specialPromoInfo={specialPromoInfo}
      changeTab={handleTabChange}
    />
  );
};
